<template>
  <li class="a-response-flow-summary-item">
    <span class="a-response-flow-summary-item__label">
      <slot>{{ label }}</slot>
      <a-tag :id="key" :color="tagInfo.color" :label="tagInfo.label" />
    </span>
    <span v-if="name" :id="name" class="a-response-flow-summary-item__name">
      {{ name }}
    </span>
  </li>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import ATag from '@/components/atoms/tag';

export default {
  name: 'a-response-flow-summary-item',
  components: {
    ATag,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    key: {
      type: String,
      default: null,
    },
  },
  computed: {
    componentTagName() {
      const baseClassName = mapModifiers('a-response-flow-summary-item__tag', this.active ? `active` : '');
      return `${baseClassName}`.trim();
    },
    tagInfo() {
      if (this.active) {
        return {
          label: '利用中',
          color: 'orange',
        };
      }
      return {
        label: '未利用',
        color: 'grey',
      };
    },
  },
};
</script>
